<style lang="scss">
    .go-iframe-dialog {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1999;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        .go-iframe-dialog-close {
            width: 100%;
            height: 8%;
            color: #fff;
            background-image: url(https://pan1.xmonster.cn/dbf0fdf8-b17f-11e6-942f-00163e002e64.png);
            background-size: 15px 15px;
            padding: 40px;
            background-position: right 30px center;
            background-repeat: no-repeat;
        }

        .go-iframe-dialog-title {
            width: 100%;
            background-image: url(https://pan1.xmonster.cn/e2867e9e-f0d4-11e9-af5c-0a580a010773.png);
            background-position: right 30px center;
            background-size: 15px 15px;
            background-repeat: no-repeat;
            background-color: #fff;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            font-size: 16px;
            color: #333333;
            text-align: center;
            line-height: 1;
            padding: 20px;
            border-bottom: 1px solid #d8d8d8;
            box-sizing: border-box;
        }

        .go-iframe-dialog-inner {
            text-align: center;
            background-color: #fff;
            width: 100%;
            height: 82%;
            font-size: 16px;
            z-index: 2100;
            /* 以下两行，ios弹出框bug */
            overflow-x: hidden;
            -webkit-overflow-scrolling: touch;
            .go-iframe-dialog-inner-iframe {
                overflow-y: scroll;
                z-index: 2222;
                width: 100%;
                height: 100%;
                margin: 0;
                padding: 0;
                border: 0;
            }
        }
    }
    .hidden {
        transform: scale(0);
        transition: 0.01s;
    }

    @media screen and (-webkit-min-device-pixel-ratio: 2) {
        .go-iframe-dialog-title {
            border-bottom-width: 0.5px;
        }
    }

    @media screen and (-webkit-min-device-pixel-ratio: 3) {
        .go-iframe-dialog-title {
            border-bottom-width: 0.333333px;
        }
    }
</style>

<template>
    <div class="go-iframe-dialog" :class="{'hidden': !iframeShow}">
        <div class="go-iframe-dialog-title" @click="closeIframe">{{iframeTitle}}</div>
        <div class="go-iframe-dialog-inner" id="go-iframe-dialog-container">
            <iframe class="go-iframe-dialog-inner-iframe" :src="iframeUrl"></iframe>
        </div>
    </div>
</template>

<script>
export default {
  name: 'IframeDialog',
  replace: true,
  data () {
    return {
      iframeUrl: '',
      iframeShow: false,
      iframeTitle: ''
    }
  },
  methods: {
    closeIframe () {
      this.iframeShow = false
      this.iframeUrl = ''
      this.iframeTitle = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/IframeDialog.vue